import en_US from "antd/lib/locale/en_US";
import zh_CN from "antd/lib/locale/zh_CN";
import zh_HK from "antd/lib/locale/zh_HK";
import ko_KR from "antd/lib/locale/ko_KR";
import ja_JP from "antd/lib/locale/ja_JP";
import hi_IN from "antd/lib/locale/hi_IN";
import id_ID from "antd/lib/locale/id_ID";
import ru_RU from "antd/lib/locale/ru_RU";
import es_ES from "antd/lib/locale/es_ES";
import tr_TR from "antd/lib/locale/tr_TR";
import vi_VI from "antd/lib/locale/vi_VN";
import th_TH from "antd/lib/locale/th_TH";
import map from "./map";

const antdLocales = {
  en: en_US,
  cn: zh_CN,
  hk: zh_HK,
  ko: ko_KR,
  ja: ja_JP,
  hi: hi_IN,
  in: id_ID,
  ru: ru_RU,
  es: es_ES,
  tr: tr_TR,
  vi: vi_VI,
  th: th_TH,
};

const appLocales = {};
map.map((obj) => (appLocales[obj.key] = {}));

const files = require.context("./lang", false, /\.json$/);
files.keys().map((key) => {
  const k = key.replace(/(^locales\/lang\/|\.json$)/g, "");
  if (appLocales[k]) {
    appLocales[k] = {
      ...appLocales[k],
      ...files(key),
    };
  }
});

export default function getLocale(locale) {
  const { key, name } = map.find(
    (obj) => obj.name === locale || obj.key === locale
  ) || {
    name: "en",
    key: "en",
    lab: "English",
  };

  return {
    key,
    name,
    antd: antdLocales[key],
    message: appLocales[key],
  };
}
